<template>
  <!-- 社教活动统计 -->
  <div class="page-digital-statistic">
    <el-row :gutter="20" class="content">
      <!-- 数据汇总 -->
      <el-col :span="24">
        <el-card class="content-item">
          <!-- <h2 class="title">活动分类统计</h2> -->
          <h2 class="title piker-title">
            <span>数据汇总</span>
            <div class="picker">
              <span class="btn-date" :class="{'active': pickerData1.type === '1'}" @click="handleClick('pickerData1', '1')">最近7天</span>
              <span class="btn-date" :class="{'active': pickerData1.type === '2'}" @click="handleClick('pickerData1', '2')">最近30天</span>

              <el-date-picker class="date-picker" v-model="pickerData1.timeArr" @change="changePicker('pickerData1')" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </div>
          </h2>

          <el-row class="mt-20" :gutter="20">
            <el-col :span="6">
              <el-card class="count-list">
                <h2>{{totalObj.activityCount}}</h2>
                <p class="m-tit mt-20">开展活动次数</p>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card class="count-list">
                <h2>{{totalObj.signCount}}</h2>
                <p class="m-tit mt-20">总报名人次</p>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card class="count-list">
                <h2>{{totalObj.realJoin}}</h2>
                <p class="m-tit mt-20">实际参加人次</p>
              </el-card>
            </el-col>
            <el-col :span="6">
              <el-card class="count-list">
                <h2>{{totalObj.commentCount}}</h2>
                <p class="m-tit mt-20">总评论人次</p>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>

      <!-- 活动分类统计 -->
      <el-col :span="24">
        <el-card class="content-item">
          <!-- <h2 class="title">活动分类统计</h2> -->
          <h2 class="title piker-title">
            <span>活动分类统计</span>
            <div class="picker">
              <span class="btn-date" :class="{'active': pickerData2.type === '1'}" @click="handleClick('pickerData2', '1')">最近7天</span>
              <span class="btn-date" :class="{'active': pickerData2.type === '2'}" @click="handleClick('pickerData2', '2')">最近30天</span>

              <el-date-picker class="date-picker" v-model="pickerData2.timeArr" @change="changePicker('pickerData2')" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </div>
          </h2>
          <div class="graph graph3">
            <div class="tab-left">
              <div class="my-table mt-20 hide">
                <el-row class="my-table-item">
                  <!-- <el-col :span="6" class="label"></el-col> -->
                  <el-col :span="item.title ? 3 : 6" :class="{'txt': index>0}" v-for="(item, index) in tableData.head" :key="index">{{item.title}}</el-col>
                  <!-- <el-col :span="3" class="txt">查看次数</el-col> -->
                </el-row>
                <el-row class="my-table-item" v-for="(it, i) in tableData.column" :key="i">
                  <el-col :span="6">
                    <div class="label">{{it.title}}</div>
                    <!-- <div class="label">实际参加</div> -->
                  </el-col>
                  <el-col class="txt" :span="3" v-for="(item, index) in it.data" :key="index">
                    <div class="label">{{item}}</div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <chart ref="chart1" :options="orgOptions1" :auto-resize="true"></chart>
          </div>

          <div class="graph graph2">
            <chart ref="chart2" :options="orgOptions2" :auto-resize="true"></chart>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import chart from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/title' //引入标题组件
import 'echarts/lib/component/legend' //引入图例组件
import 'echarts/lib/component/tooltip' //引入图例组件
import 'echarts/lib/component/dataZoom' // 滚动条插件
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/treemap'
import moment from 'moment'
export default {
  components: {
    chart
  },
  data() {
    // console.log(
    //   moment()
    //     .subtract(30, 'days')
    //     .format('YYYY-MM-DD')
    // )
    // console.log(moment().format('YYYY-MM-DD'))
    return {
      totalObj: {}, // 总量统计
      tableData: {
        head: [],
        column: []
      },
      orgOptions1: {},
      orgOptions2: {},
      pickerData1: {
        timeArr: [],
        type: '1'
      },
      pickerData2: {
        timeArr: [],
        type: '1'
      }
    }
  },
  methods: {
    handleClick(picker, type) {
      this[picker].timeArr = []
      this[picker].type = type
      this.refreshChrt(picker)
    },
    changePicker(picker) {
      if (!this[picker].timeArr) {
        this[picker].timeArr = []
        this[picker].type = '1'
      } else {
        this[picker].type = ''
      }
      this.refreshChrt(picker)
    },
    refreshChrt(picker) {
      switch (picker) {
        case 'pickerData1':
          this.getStatisticsSource()
          break
        case 'pickerData2':
          this.getTypeStatistics()
          break
      }
    },
    // 总量统计
    getStatisticsSource() {
      this.$http
        .get('/bsActivityStatistics/summaryStatistics', {
          type: this.pickerData1.type, //	string	类型 （1-本周 2-本月 3-全年）
          startTime: this.pickerData1.timeArr[0], //	string	开始时间
          endTime: this.pickerData1.timeArr[1] //	string	结束时间
        })
        .then(res => {
          if (res.success) {
            this.totalObj = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 活动分类统计
    getTypeStatistics() {
      this.$http
        .get('/bsActivityStatistics/typeStatistics', {
          type: this.pickerData2.type, //	string	类型 （1-本周 2-本月 3-全年）
          startTime: this.pickerData2.timeArr[0], //	string	开始时间
          endTime: this.pickerData2.timeArr[1] //	string	结束时间
        })
        .then(res => {
          if (res.success) {
            let data = res.result
            this.tableData = data.table
            this.setChat1(data.pie)
            this.setChat2(data.line)

            window.removeEventListener('resize', this.resizeEvent)
            window.addEventListener('resize', this.resizeEvent)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    resizeEvent() {
      console.log('resize')
      for (let i = 1; i <= 2; i++) {
        this.$refs['chart' + i] && this.$refs['chart' + i].resize() //初始化的
      }
    },
    setChat1(data) {
      this.orgOptions1 = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        // legend: {
        // orient: 'vertical',
        // left: 'left',
        // data: ['直接访问', '邮件营销', '联盟广告']
        // },
        series: [
          {
            name: '分类统计',
            type: 'pie',
            radius: '70%',
            center: ['50%', '50%'],
            data: data,
            // data: [
            //   { value: 335, name: '直接访问' },
            //   { value: 310, name: '邮件营销' },
            //   { value: 234, name: '联盟广告' }
            // ],
            // itemStyle: {
            //   emphasis: {
            //     shadowBlur: 10,
            //     shadowOffsetX: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0.5)'
            //   }
            // },
            color: ['#0590FF', '#2EC7C9', '#D87A80']
          }
        ]
      }
    },
    setChat2(data) {
      this.orgOptions2 = {
        // title: {
        //   text: '征集统计',
        //   textStyle: {
        //     fontSize: 18,
        //     color: '#575962'
        //   }
        // },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: data.legend
        },
        grid: {
          left: '11%', //组件离容器左侧的距离
          right: '17%',
          top: '20%',
          bottom: '18%',
          containLabel: true //grid 区域是否包含坐标轴的刻度标签
        },
        xAxis: {
          type: 'category',
          data: data.xAxis,
          // data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          // show: false,
          axisLabel: {
            // interval:0,
            rotate: 45
          }
        },
        yAxis: {
          type: 'value'
        },
        // x轴拖动
        dataZoom: {
          type: 'slider',
          realtime: true, //拖动滚动条时是否动态的更新图表数据
          height: 20, //滚动条高度
          start: 0, //滚动条开始位置（共100等份）
          end: 100 //结束位置（共100等份）
          // left: 80,
          // right: 80
        },
        series: data.data,
        // series: [
        //   {
        //     name: '自动采集',
        //     type: 'line',
        //     stack: '总量',
        //     data: [120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name: '人工上传',
        //     type: 'line',
        //     stack: '总量',
        //     data: [220, 182, 191, 234, 290, 330, 310]
        //   }
        //   // {
        //   //   // data: data.yAxis,
        //   //   data: [820, 932, 901, 934, 1290, 1330, 1320],
        //   //   type: 'line'
        //   // }
        // ],
        // type: 'line',
        // smooth: true
        color: ['#0590FF', '#2EC7C9']
      }
    }
  },
  created() {
    this.getStatisticsSource()
    this.getTypeStatistics() // 活动分类统计
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEvent)
  }
}
</script>


<style lang="scss" scoped>
.page-digital-statistic {
  .content {
    .content-item {
      margin-bottom: 20px;

      .graph {
        height: 300px;
        .echarts {
          width: 100%;
          height: 100%;
        }
        &.graph2 {
          position: relative;
          // padding-left: 100px;
          .title-left {
            position: absolute;
            left: 0;
            top: 0;
            width: 100px;
            height: 100%;
            display: flex;
            flex-direction: column;
            // justify-content: space-between;
            box-sizing: border-box;
            .title-left-item {
              margin-bottom: 50px;
              h2 {
                line-height: 40px;
                font-size: 16px;
                // font-weight: normal;
              }
            }
          }
        }

        &.graph3 {
          position: relative;
          height: auto;
          // min-height: 300px;
          display: flex;
          .echarts {
            flex: 1;
            height: 300px;
          }
          .tab-left {
            width: 700px;
            height: 100%;
            padding-right: 20px;
            padding-top: 20px;
            box-sizing: border-box;
            .my-table-item.list {
              .label {
                border-bottom: solid 1px $border;
              }
              .txt {
                padding: 0;
              }
            }
          }
        }
      }

      h2.title {
        font-size: 18px;
        color: #575962;
        line-height: 40px;
      }

      .piker-title {
        position: relative;
        display: flex;
        z-index: 2;
        .picker {
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-weight: normal;
          /deep/.el-date-editor .el-range-separator{
            width: 11%;
          }
          .btn-date {
            margin-right: 15px;
            font-size: 14px;
            color: $color5;
            cursor: pointer;
            &.active {
              color: $primary;
            }
          }
          .date-picker {
            width: 250px;
          }
        }
      }

      .my-table {
        display: inline-block;
        width: 100%;

        .my-table-item {
          display: flex;
          justify-content: space-around;
          line-height: 30px;
          border: solid 1px $border;
          border-bottom: none;
          text-align: center;
          font-size: 14px;
          .txt {
            padding: 0 5px;
            border-left: solid 1px $border;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          &:last-child {
            border-bottom: solid 1px $border;
          }
        }
      }
    }
  }
  /deep/ .el-card__body {
    padding: 20px;
  }
}
</style>

